export default "__VITE_ASSET__8bboTDGf__"